import axios from 'axios';

// Use environment variable or fallback to production server
const baseURL = import.meta.env.VITE_API_BASE_URL || "https://api.aurelia-apartments.com/api/";

const api = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        
    },
    withCredentials: false,  // Disable credentials for cross-domain requests
    timeout: 30000, // Increase timeout to 30 seconds
});

// Add auth token to requests if it exists
api.interceptors.request.use((config) => {
    // The instance-wide default Content-Type above is 'application/json' —
    // axios's transformRequest sees that on a FormData body and JSON-encodes
    // it instead of sending real multipart data (a File becomes '{}'), so
    // uploads (e.g. the kitchen menu-item image) silently arrive as no file
    // at all. Dropping the header here lets the browser set the correct
    // 'multipart/form-data; boundary=...' Content-Type itself.
    if (config.data instanceof FormData) {
        delete config.headers["Content-Type"];
    }

    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        // Log token info for /chopnation routes
        if (config.url?.includes('/chopnation')) {
            console.log(`[Axios] Sending token to ${config.url}`, {
                tokenPresent: !!token,
                tokenLength: token?.length,
                authHeader: config.headers.Authorization?.substring(0, 20) + '...'
            });
        }
    } else if (config.url?.includes('/chopnation')) {
        console.warn(`[Axios] No token found for ${config.url}`);
    }
    return config;
});

// Log responses for chopnation
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.config?.url?.includes('/chopnation')) {
            console.error(`[Axios] Error on ${error.config.url}`, {
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data
            });
        }
        return Promise.reject(error);
    }
);

export default api;
